import { TimeMinutesFormat } from '@/models/common';
import { PreOrder } from '@/models/order';
import { getTotalDuratonBySKUSpecifications } from '@/models/sku';
import { Flex, Progress } from 'antd';
import dayjs from 'dayjs';
import { Duration } from 'dayjs/plugin/duration';
import { useEffect, useState } from 'react';

/**
 * 服务计时器
 * 始终按照商品设定的预计时长计算
 * @param param0
 * @returns
 */
export const ServiceTimer = ({ preOrder }: { preOrder: PreOrder }) => {
  const specifications = preOrder.specifications;
  const totalDuration = getTotalDuratonBySKUSpecifications(specifications);

  // 当前时间到结束时间的 duration
  const [durationToEnd, updateDurationToEnd] = useState<Duration>();
  const [endTime, setEndTime] = useState<dayjs.Dayjs>();

  useEffect(() => {
    if (preOrder.addTime) {
      const endTime = dayjs(preOrder.addTime).add(totalDuration, 'minute');
      setEndTime(endTime);
    }
    const updater = () => {
      updateDurationToEnd(dayjs.duration(dayjs().diff(preOrder.addTime)));
    };
    const timer = setInterval(updater, 1 * 1000);
    updater();
    return () => {
      clearInterval(timer);
    };
  }, [preOrder]);

  const notStart = !preOrder.addTime || !durationToEnd;

  return (
    <Flex gap={8} vertical={false} justify="space-between" align="center">
      <Progress
        size="small"
        steps={6}
        percent={((durationToEnd?.asMinutes() ?? 0) / totalDuration) * 100}
        format={() => {
          if (notStart) {
            return <>未开始</>;
          }
          const minutes = Math.floor(durationToEnd.asMinutes());
          const seconds = durationToEnd.seconds();
          const display = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

          return (
            <>
              {display} / {totalDuration}
              分钟
            </>
          );
        }}
      />
      {!notStart && endTime ? (
        <div>计划完成: {endTime?.format(TimeMinutesFormat)}</div>
      ) : (
        <div>时长: {totalDuration}分钟</div>
      )}
    </Flex>
  );
};
